// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offline-banner {
  position: sticky;
  top: 0;
  z-index: 10000;
  width: 100%;
  padding: 0.65rem 1rem;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  color: #7a2e0e;
  background: #fff3cd;
  border-bottom: 1px solid #ffe69c;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/OfflineBanner.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,yCAAyC;AAC3C","sourcesContent":[".offline-banner {\n  position: sticky;\n  top: 0;\n  z-index: 10000;\n  width: 100%;\n  padding: 0.65rem 1rem;\n  text-align: center;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #7a2e0e;\n  background: #fff3cd;\n  border-bottom: 1px solid #ffe69c;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
